<template>
    <div>
        <vx-auto-suggest-modified
            ref="suburbSuggest"
            v-bind="attrs"
            background-overlay
            hide-group-title
            class="vx-auto-suggest-modified w-full"
            input-classes="w-full vs-input-no-shadow-focus"
            icon="SearchIcon"
            prevent-filtering
            :value="searchText"
            :autofocus="autofocus || showFullSearch"
            :data="predictions"
            :selected.sync="selected"
            :show-on-focus="true"
            @input="searchChanged"
            @blur="(e) => $emit('blur', e)"
            @focus="(e) => $emit('focus', e)"
            @close-searchbar="closeFullSearch"
        >
            <template v-slot:suburbs="{ suggestion }">
                <slot name="suburbs" :place="suggestion">
                    <div class="flex items-center leading-none py-1">
                        {{ suggestion }}
                    </div>
                </slot>
            </template>

            <!-- Loading Slot -->
            <template v-slot:loader>
                <vx-spinner
                    scale="0.6"
                    :type="loaderState == 'listening' ? 'sound' : 'default'"
                ></vx-spinner>
            </template>

            <!-- No Items Slot -->
            <template v-slot:noResult>
                <slot name="noResult">
                    <div class="flex items-center">
                        <feather-icon icon="InfoIcon" svgClasses="h-6 w-6" class="mr-4" />

                        <span v-if="waitingForMoreText">Keep typing...</span>
                        <span v-else>No matching places</span>
                    </div>
                </slot>
            </template>
        </vx-auto-suggest-modified>
    </div>
</template>

<script>
export default {
    name: 'vx-suburb-suggest',
    props: {
        value: {
            type: [Object, String]
        },
        debounce: {
            type: Number,
            default: 100
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        selectLike: {
            type: Boolean,
            default: true
        },
        showOnFocus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchText: '',
            showFullSearch: false,
            typingTimeout: null,
            prediction_results: [],
            loading_predictions: false,
            apiKey: 'f4646b20-18c5-4e64-91bf-11ff07c472fa'
        }
    },
    watch: {
        value: {
            handler(v) {
                this.searchText = v == null ? '' : v.toUpperCase()
                this.prediction_results = []
                this.loading_predictions = false
            }
        }
    },
    computed: {
        waitingForMoreText() {
            if (this.searchText) {
                return this.searchText.length <= 2
            }
            return true
        },
        predictions() {
            return {
                suburbs: {
                    loading: this.loading_predictions,
                    getSearchText: this.getSearchText,
                    data: this.prediction_results || [],
                    id: this.getSearchText // to avoid error in suggest
                }
            }
        },
        attrs() {
            return { ...this.$attrs, selected: null }
        },
        selected: {
            get() {
                return this.value == null ? '' : this.value.toUpperCase()
            },
            set(val) {
                this.onSelected(val)
            }
        },
        loaderState() {
            if (this.typingTimeout != null || this.waitingForMoreText) {
                return 'listening'
            } else {
                return 'loading'
            }
        }
    },
    methods: {
        focus() {
            this.$refs.suggest.focus()
        },
        searchChanged(term) {
            this.loading_predictions = true
            this.searchText = term

            if (this.waitingForMoreText) {
                return
            }
            if (this.typingTimeout) {
                clearTimeout(this.typingTimeout)
                this.typingTimeout = null
            }
            this.typingTimeout = setTimeout(
                function () {
                    this.typingTimeout = null
                    try {
                        if (term) {
                            this.fetchPredictions(term)
                            return
                        }
                        this.prediction_results = []
                    } finally {
                        this.loading_predictions = false
                    }
                }.bind(this),
                this.listenFor
            )
        },
        async fetchPredictions(term) {
            if (this.waitingForMoreText) {
                this.prediction_results = []
                this.loading_predictions = false
                return
            }
            if (this.value && this.value == term) {
                this.closeFullSearch()
                return
            }

            try {
                this.loading_predictions = true
                this.prediction_results = await this.fetchPredictionsAsync(term)
            } catch (err) {
                console.error(err)
            } finally {
                this.loading_predictions = false
            }
        },
        closeFullSearch() {
            this.showFullSearch = false
        },
        async fetchPredictionsAsync(term) {
            try {
                var response = await this.$http.get(
                    `https://api.addressify.com.au/address/suburbAutocomplete?api_key=${this.apiKey}&term=${term}`
                )
                return response.data
            } catch (error) {
                console.error(error)
            }
        },
        getSearchText(item) {
            if (item) {
                return item
            }
            return ''
        },
        onSelected({ item }) {
            if (this.value && this.value == item) {
                return
            }
            try {
                this.$emit('input', item)
            } catch (err) {
                this.$emit('error', item)
                this.notifyError(
                    'Missing Record',
                    `Could not find details for ${this.searchText}. ${err}`,
                    8000
                )
            }
            this.closeFullSearch()
        }
    },
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped></style>
